import { render, staticRenderFns } from "./AuditFormPerformer.vue?vue&type=template&id=3fff669f&scoped=true&"
import script from "./AuditFormPerformer.vue?vue&type=script&lang=js&"
export * from "./AuditFormPerformer.vue?vue&type=script&lang=js&"
import style0 from "./AuditFormPerformer.vue?vue&type=style&index=0&id=3fff669f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fff669f",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox, CFlex: require('@chakra-ui/vue').CFlex})
